import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-309480e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-container" }
const _hoisted_2 = {
  key: 0,
  class: "sent-items"
}
const _hoisted_3 = {
  key: 1,
  class: "pending-items"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/assets/logocolor_mini.jpg"
}, null, -1))
const _hoisted_7 = { class: "totals" }
const _hoisted_8 = {
  key: 0,
  class: "total-sent"
}
const _hoisted_9 = {
  key: 1,
  class: "total-sent"
}
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "order-comments-container" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"120px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_order_items = _resolveComponent("order-items")!
  const _component_payments_summary_card = _resolveComponent("payments-summary-card")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_payment_modal = _resolveComponent("payment-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: _normalizeClass({ 'items-loading': _ctx.loading })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "btn-back",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHome && _ctx.openHome(...args)))
            }, [
              _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
            ]),
            (_ctx.hasSentItems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("cart.sentToKitchen")), 1),
                  _createVNode(_component_order_items, {
                    itemsByUser: _ctx.sentItems,
                    onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCart(false))),
                    payNow: _ctx.payNow
                  }, null, 8, ["itemsByUser", "payNow"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasActiveItems)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (!_ctx.payNow)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t("cart.pendingItems")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.payNow)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.$t("cart.myOrder")), 1),
                        _hoisted_6
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_items, {
                    itemsByUser: _ctx.activeItems,
                    onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCart(false))),
                    payNow: _ctx.payNow
                  }, null, 8, ["itemsByUser", "payNow"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.payNow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t("cart.sentToKitchen")) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.totalSent)), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.payNow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.$t("cart.pendingSend")) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.totalPending)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("cart.total")) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.totalSent + _ctx.totalPending)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (!_ctx.showAddComment)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleShowAddComment && _ctx.handleShowAddComment(...args)))
                }, _toDisplayString(_ctx.$t("cart.addNote")), 1))
              : _createCommentVNode("", true),
            (_ctx.showAddComment)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.comment) = $event)),
                  ref: "commentTextarea",
                  class: "order-comments form-control",
                  placeholder: _ctx.$t('cart.addNoteHint')
                }, null, 8, _hoisted_12)), [
                  [_vModelText, _ctx.comment]
                ])
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_payments_summary_card),
          _hoisted_13,
          (_ctx.totalPending > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["pay-btn", { 'btn-loading': _ctx.placingOrder }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.placeOrder(false)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("cart.sendToKitchen")), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.totalPending)), 1),
                _createVNode(_component_ion_spinner, { name: "dots" })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.totalPending === 0 && _ctx.totalSent > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["pay-btn", { 'btn-loading': _ctx.placingOrder }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.placeOrder(true)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("cart.pay")), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.totalSent)), 1),
                _createVNode(_component_ion_spinner, { name: "dots" })
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_payment_modal, {
            ref: "paymentModal",
            comment: _ctx.comment,
            onPaymentSuccess: _ctx.handleOrderSuccess
          }, null, 8, ["comment", "onPaymentSuccess"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}